import $x from '@/utils/$x';

/**
 * save
 * @param {*} params
 * @returns
 */
export async function saveActivity(params) {
  return $x.post('/litta/promotion/activity/save', params);
}

/**
 * 营销活动列表
 * @param {*} params
 * @returns
 */
export async function listActivity(params) {
  return $x.post('/litta/promotion/activity/list', params);
}

/**
 * 删除营销活动
 * @param {*} params
 * @returns
 */
export async function deleteActivity(params) {
  return $x.post('/litta/promotion/activity/delete', params);
}

/**
 * 查询营销活动
 * @param {*} params
 * @returns
 */
export async function findByIdActivity(params) {
  return $x.post('/litta/promotion/activity/findById', params);
}

/**
 * 营销活动-上下架
 * @param {*} params
 * @returns
 */
export async function onlineOrOffLineActivity(params) {
  return $x.post('/litta/promotion/activity/onlineOrOffLine', params);
}

/**
 * 优惠券-列表 http://172.16.150.60:7700/#/view/Q2V71wN8
 * @param {*} params
 * @returns
 */
export async function couponList(params) {
  return $x.post('/litta/reward/coupon/list', params);
}

/**
 * 优惠券-总列表 http://172.16.150.60:7700/#/view/Q2V71wN8
 * @param {*} params
 * @returns
 */
export async function couponListAll(params) {
  return $x.post('/litta/reward/coupon/listAll', params);
}

/**
 * 优惠券-保存 http://172.16.150.60:7700/#/view/aXYVrkkz
 * @param {*} params
 * @returns
 */
export async function couponSave(params) {
  return $x.post('/litta/reward/coupon/save', params);
}

/**
 * 优惠券-通过ID获取详情 http://172.16.150.60:7700/#/view/kXOeEQx2
 * @param {*} params
 * @returns
 */
export async function couponFindById(params) {
  return $x.post('/litta/reward/coupon/findById', params);
}

/**
 * 优惠券-上架 or 失效 http://172.16.150.60:7700/#/view/xXamWpAX
 * @param {*} params
 * @returns
 */
export async function couponOnlineOrInvalid(params) {
  return $x.post('/litta/reward/coupon/onlineOrInvalid', params);
}

/**
 * 优惠券-用户领取列表 http://172.16.150.60:7700/#/view/a26mbjNz
 * @param {*} params
 * @returns
 */
export async function couponRecordList(params) {
  return $x.post('/litta/reward/coupon/couponRecordList', params);
}

/**
 * 优惠券-后台充值
 * @param {*} params
 * @returns
 */
export async function receiveCouponActivity(params) {
  return $x.post('/litta/reward/coupon/receiveCouponActivity', params);
}
